import getUserLanguage from 'src/utils/getUserLanguage'

type RedirectToAppointmentOptions = {
  doctorId: number
  lpuId: number
  slot: string
  specialityId: number
  type?: string
}

/**
 * Редирект на форму записи врача — тот же URL, что у legacy ScheduleLpu.
 *
 * Source `lpu-inner` — как у LocationParser на странице клиники.
 * LocationParser намеренно не импортируем: его граф (`utils` → getProfession →
 * CASE_NOUN) и `window` в REGEXP_PATTERNS ломают Vue SSR.
 */
export default function redirectToAppointment({
  doctorId,
  lpuId,
  slot,
  specialityId,
  type,
}: RedirectToAppointmentOptions) {
  if (typeof window === 'undefined') {
    return
  }

  const userLanguage = getUserLanguage()
  let host = `${window.location.origin}/`

  if (
    window.LANGUAGE_DATA
    && userLanguage !== window.LANGUAGE_DATA.defaultLanguageIso
  ) {
    host += `${userLanguage}/`
  }

  const params = new URLSearchParams({
    doctor: String(doctorId),
    source: 'lpu-inner',
    slot,
    lpu: String(lpuId),
    speciality: String(specialityId),
  })

  if (type && type !== 'default') {
    params.set('type', type)
  }

  window.location.href = `${host}appointment/vrach/new/?${params.toString()}`
}
